export const TABLE_HEAD = [
  'Email',
  'Role',
  'First name',
  'Last name',
  'Created date',
  'Actions',
];
